import { useQuery } from '@tanstack/react-query';
import { FC } from 'react';
import styled from 'styled-components';

import { ResponsiveTable, Table, TableContent, Th } from '@/components/Table';
import { api } from '@/utils/api';

import CoverImagesNewTableRow from './CoverImagesNewTableRow';

const StyledTable = styled(Table)`
  th,
  td {
    padding: 16px 12px;
    vertical-align: top;
    &:nth-child(1) {
      width: 45%;
      padding-left: 24px;
    }
    &:nth-child(2) {
      width: 20%;
    }
    &:nth-child(3) {
      width: 20%;
    }
    &:nth-child(4) {
      width: 15%;
    }
  }
  td {
    font-size: 12px;
    font-weight: 700;
  }
`;

interface Props {
  isDrafts: boolean;
}

const CoverImagesNewTable: FC<Props> = ({ isDrafts }) => {
  const {
    data: projects,
    isLoading,
    isError,
  } = useQuery(['new_cover_images_projects', { isDrafts }], () =>
    api.get<
      never,
      {
        title: string;
        slug: string;
        id: number;
        date_created: number;
        author_email: string;
        post_status: string;
        author_name: string;
        is_open_list: boolean;
      }[]
    >('/v1/cover-images/new-cover-images-projects', {
      params: {
        isDrafts,
      },
    }),
  );

  return (
    <>
      <ResponsiveTable>
        <StyledTable $fixed>
          <thead>
            <tr>
              <Th>Post Name</Th>
              <Th>Date Created</Th>
              <Th>Editor</Th>
              <Th>Is Open List</Th>
            </tr>
          </thead>
          <tbody>
            <TableContent
              isLoading={isLoading}
              colSpan={4}
              isError={isError}
              hasData={!!projects?.length}
            >
              {projects?.map((article, index) => (
                <CoverImagesNewTableRow key={index} article={article} />
              ))}
            </TableContent>
          </tbody>
        </StyledTable>
      </ResponsiveTable>
    </>
  );
};

export default CoverImagesNewTable;
